import React, { useState, useEffect, useRef } from "react";
import { withRouter, Redirect } from "react-router";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  QUERY_GET_GAME,
  QUERY_PARTICIPATE_IN_TOURNAMENT,
  QUERY_CANCEL_ALL_BONUSES,
  //QUERY_ACK_RESPONSIBLE_GAMING_ALERT,
  QUERY_GET_TIMEOUT,
  QUERY_GET_BLOCKED_GAMES,
  QUERY_GET_BLOCKED_GAME_TYPES,
  QUERY_REALITY_CHECK,
  //QUERY_SESSION_TIMEOUT,
  QUERY_CHECK_EXPERIAN,
  QUERY_GET_LIMITS,
} from "common/src/graphql/queries";
import {
  MUTATION_UPDATE_PROFILE,
  MUTATION_SET_LEADERBOARD_NAME,
} from "common/src/graphql/mutations";
import { useApolloClient } from "@apollo/client";
import { touchStartHandler } from "common/src/helpers/dragndrop";
import {
  isDesktop,
  isMobile,
  isTablet,
  useMobileOrientation,
} from "react-device-detect";
// import { WithdrawAlertDialog } from "../modal/WithdrawAlertDialog";
//import { ResponsibleGamingDialog } from "common/src/modal/ResponsibleGamingDialog";
//import SearchResults from "common/src/component/SearchResults";
import { getToken } from "common/src/helpers/session";
import { ChallengeDialog } from "common/src/modal/ChallengeDialog";
import Deposit from "./Deposit";
import { SetRealityCheckDialog } from "common/src/modal/SetRealityCheckDialog";
import { TournamentPopover } from "common/src/modal/TournamentPopover";
import { LeaderboardDialog } from "common/src/modal/LeaderboardDialog";
import { OnlyBonusDialog } from "common/src/modal/OnlyBonusDialog";
import { BonusLiveAlertDialog } from "common/src/modal/BonusLiveAlertDialog";
import { BonusConfirmationWrapper } from "common/src/modal/BonusConfirmationWraper";
import { RealityCheckDialog } from "common/src/modal/RealityCheckDialog";
import { ReactComponent as Close } from "../data/icon-component/close.svg";
import { ReactComponent as FullScreen } from "../data/icon-component/full_scr.svg";
import SidePanel from "common/src/component/SidePanel";
import config from "../config.json";
/* import { SessionLimitDialog } from '../modal/SessionLimitDialog'; */
//import { NlLimitDialog } from "common/src/modal/NlLimitDialog";
import {
  FullPageOverlay,
  /* GameAlignCenter,
  GameCasinoTimeWrapper, */
  GameCommands,
  GameContent,
  GameDetailWrapper,
  GameFullscreanWrapper,
  GamePanelHeader,
  GamePanelSE,
  GameSpinner,
  IngameDeposit,
  /* LobbyWrapper, */
  QuickDeposit,
  SidepanelButton,
  StyledDoubleArrowsLeft,
  StyledDoubleArrowsRight,
  StyledGameFlex,
  StyledGameWrapper,
  StyledSELink,
  IFrame,
  DepositInGameWrapper,
  DepositInGameBox,
  /* GameAlignCenter,
  GameCasinoTimeWrapper, */
} from "common/src/styledComponents/StyledGame";
import {
  StyledButton,
  StyledLink,
  StyledMx,
} from "common/src/styledComponents/CommonStyledComponents";
import useFullscreen from "common/src/helpers/useFullscreenStatus";
import { useDate } from "common/src/helpers/functions";
import { GameSessionStats } from "common/src/component/GameSessionStats";
/* import { checkSWEDepositLimit } from "common/src/helpers/checkSWEDepositLimit"; */
//import { SessionLimitDialog } from "common/src/modal/SessionLimitDialog";
import handleOrientationChange from "common/src/helpers/orientationChange";
//import realityCheckNetent from "../helpers/realityCheckNetent";
import SportsBook from "./SportsBook";
/* import Time from "common/src/component/Time"; */
import sjaelvtest from "common/src/assets/img/sjaelvtest.svg";
import spelgraenser from "common/src/assets/img/spelgraenser.svg";
import spelpaus from "common/src/assets/img/spelpaus.svg";
import arrowAlt from "common/src/assets/img/arrows-alt.svg";
import arrowAltTwo from "common/src/assets/img/arrows-alt-two.svg";
import { touchStartHandlerDeposit } from "common/src/helpers/dragndropDeposit";

const GameWindow = ({
  currentTheme,
  currentLanguage,
  pageWidth,
  pageHeight,
  bannedCasinoPage,
  bannedLiveCasinoPage,
  bannedSportsbookPage,
  bannedDepositPage,
  riskyCountry,
  player,
  onToggleSearchShow,
  balance,
  wagering,
  searchResults,
  cancelWithdrawal,
  hasWithdraw,
  server,
  setSpinner,
  depositList,
  getBalance,
  getWageringBonus,
  setShowWithdrawAlertDialog,
  setSweLimitDialog,
  //setNlLimitDialog,
  mobileGame,
  pages,
  setPxDepositStart,
  sidepanel,
  setSidepanel,
  grossResults,
  firstDeposit,
  socket,
  titles,
}) => {
  const history = useHistory();
  const { country, realityCheck, leaderboard, tc, currency, callcreditTime } =
    player;
  const { t } = useTranslation("");

  //console.log(pageWidth + " " + pageHeight);
  let playerCurrency =
    currency === undefined ? config.defaultCurrency.toLowerCase() : currency;
  const [gameId] = useState(useLocation().pathname.split("/")[3]);
  const gameCategory = useRef(useLocation().pathname.split("/")[2]);
  // const [serverSetup] = useState(sessionStorage.getObject(SERVER_SETUP));
  const [gameDetails, setGameDetails] = useState(null);
  const [tournaments, setTournaments] = useState(null);
  const apolloClient = useApolloClient();
  //popup

  /* const [showResponsibleGamingDialog, setShowResponsibleGamingDialog] =
    useState(false); */
  // const [showWithdrawAlertDialog, setShowWithdrawAlertDialog] = useState(false);
  const [showTournamentPopover, setShowTournamentPopover] = useState(false);
  const [showRealityCheckDialog, setshowRealityCheckDialog] = useState(false);
  const [showLeaderboardDialog, setShowLeaderboardDialog] = useState(false);
  const [bonusConfirmationWrapper, setBonusConfirmationWrapper] =
    useState(false);
  //const [showSessionLimitDialog, setShowSessionLimitDialog] = useState(false);
  const [hasTimeout, setHasTimeout] = useState(false);
  const [rcValue, setRcValue] = useState({});
  const [errors, setErrors] = useState({});
  const [onlyBonusDialog, setOnlyBonusDialog] = useState(false);
  const [bonusLiveAlertDialog, setBonusLiveAlertDialog] = useState(false);
  const [showChallengeDialog, setShowChallengeDialog] = useState(false);
  const [gameRedirect, setGameRedirect] = useState(false);
  const [depositRedirect, setDepositRedirect] = useState(false);
  const [showDeposit, setShowDeposit] = useState(false);
  const [blockedGames, setBlockedGames] = useState([]);
  const [clearGameSearch, setClearGameSearch] = useState(false);
  const [blockedGameTypes, setBlockedGameTypes] = useState([]);
  const [gross, setGross] = useState(null);
  const [gameSession /* setGameSession */] = useState(null);
  const [showDepositButton, setShowDepositButton] = useState(true);
  const { isLandscape } = useMobileOrientation();

  /* const redirectTo = config.skin !== "plc" ? "index" : "games"; */

  //let period = 10000;
  let periodRC = 10000;
  let realityTimer = useRef(false);
  //let intervalId = useRef(undefined);
  let intervalRC = useRef(undefined);

  //check deposit limit for swe
  const isSE = country === "se" ? true : false;
  const isUK = country === "gb" ? true : false;
  const isNL = country === "nl" ? true : false;

  const maximizableElement = React.useRef(null);
  let toggleFullscreen;
  /* let inFullscreenMode; */

  [toggleFullscreen /* inFullscreenMode */] = useFullscreen(maximizableElement);

  const gameOnFullScr = () => {
    let elem = document.getElementById("fs-wrapper");
    /*  document
      .getElementById("neGameClient")
      .setAttribute("style", "width:100% ;height:100%"); */
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    }
  };

  useEffect(() => {
    document.title = gameId
      ? gameId.charAt(0).toUpperCase() +
        gameId.slice(1).replace(/-/g, " ") +
        " | Hyper Casino"
      : "Hyper Casino";

    setTimeout(() => {
      setShowDepositButton(false);
    }, 1000);
    closeDeposit(true);
  }, [gameId]);

  useEffect(() => {
    const checkRC = async () => {
      // console.log("reality check function");
      const { data } = await apolloClient.query({
        query: QUERY_REALITY_CHECK,
        variables: { period: periodRC / 1000 },
      });
      if (data.getRealityCheckStats.display !== undefined) {
        //reality check
        //console.log('reality check ' + data.getRealityCheckStats.display);
        if (data.getRealityCheckStats.display) {
          //display reality check dialog on game play reality-check-dialog
          setshowRealityCheckDialog(true);
          setRcValue(data.getRealityCheckStats.stats);
        }
      }
    };
    socket &&
      socket.on("message", (data) => {
        console.log("game socket " + JSON.stringify(data));
        if (typeof data.action !== "undefined") {
          let action = data.action;
          switch (action) {
            case "end-game-session":
              console.log(
                "-------- end game session redirect for playngo---------"
              );
              if (gameDetails.game.vendor === "playngo") {
                window.location = pages["index"];
              }
              break;
            case "start-reality-check":
              if (!realityTimer.current) {
                realityTimer.current = true;
                // console.log(JSON.stringify(realityTimer.current));
                intervalRC.current = setInterval(function () {
                  checkRC();
                }, 10000);
              }
              break;
            case "session-stats":
              /* console.log(
                "gross " +
                  (data.bet - data.win) +
                  "vreme koje je proteklo otkad je sesija startovana " +
                  data.started_at,
              ); */
              setGross(data.win - data.bet);
              //setGameSession(data.started_at);
              break;
            default:
              break;
          }
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apolloClient, socket, pages, periodRC]);

  useEffect(() => {
    return () => clearInterval(intervalRC.current);
  }, []);

  /*  useEffect(() => {
    
  }, []); */

  const { time } = useDate(gameSession);

  /*   useEffect(() => {
    async function check() {
      const { data } = await apolloClient.query({
        query: QUERY_SESSION_TIMEOUT,
        variables: { period: period / 1000 },
      });
      return data.getSessionTimeout;
    }
    if (socket) {
      check().then((data) => {
        if (data.allow !== undefined && !data.allow) {
          console.log("session-limit " + data.allow);
          //session-limit
          setShowSessionLimitDialog(true);
        }
      });
      var interval = setInterval(function () {
        check().then((data) => {
          //console.log(data.allow);
          if (data.allow !== undefined && !data.allow) {
            console.log("session-limit " + data.allow);
            //session-limit
            !showSessionLimitDialog && setShowSessionLimitDialog(true);
          }
        });
      }, period);
    }
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apolloClient, currentLanguage, period]);
 */

  useEffect(() => {
    async function experianCheck() {
      //TODO: check if its already checked
      // console.log("callcredit: " + callcreditTime + " " + callcreditStatus)
      if (callcreditTime === "") {
        const { loading, errors, data } = await apolloClient.query({
          query: QUERY_CHECK_EXPERIAN,
        });

        if (loading) return <h3>Loading ...</h3>;
        if (errors) {
          toast.error(errors[0].message, {
            position: "bottom-center",
          });
          return false;
        }

        if (data.checkExperian.lock) {
          sessionStorage.setItem("user_banned_from_page", true);
          window.location.replace(pages[`support`]);
        }
      }
    }

    isUK && experianCheck();
  }, [apolloClient, callcreditTime, isUK, pages]);

  //on search and selected game
  /* useEffect(() => {
    searchResults !== null && setResultsHasChanged(true);
    setgameSelected(false);
  }, [searchResults]);
  useEffect(() => {
    setgameSelected(true);
    setResultsHasChanged(false);
  }, [gameId]); */

  let tournamentDescription =
    tournaments !== null && tournaments.length > 0
      ? tournaments[0].tournamentDescription
      : "text_without_tournament_description";

  let sidepanelHeight;
  //game play size
  if (gameDetails !== null) {
    let ratio = gameDetails.client !== "flash" ? "16/9" : "4/3";
    var gameHeight = pageHeight - 100;
    var rParts = ratio.split("/");
    var gameWidth = gameHeight / (rParts[1] / rParts[0]);

    if (sidepanel) {
      gameWidth = pageWidth - 500;
    } else {
      gameWidth = pageWidth - 150;
    }

    var realheight = `${gameWidth * (rParts[1] / rParts[0])}px`;
    sidepanelHeight = `${gameWidth * (rParts[1] / rParts[0]) - 200}px`;
    gameWidth = `${gameWidth}px`;

    /* var gameDiv = document.getElementById("neGameClient");
    gameDiv &&
      gameDiv.setAttribute("style", `height:${realheight} ;width:${gameWidth}`); */

    if (isMobile) {
      gameWidth = pageWidth;
      realheight = gameHeight;
    }
  }

  const isUKIP = server.geoIP.isoCode.toLowerCase() === "gb" ? true : false;
  /* 
  const isSWEIp = () => {
    const geoIP = server.geoIP.isoCode.toLowerCase();
    if (getToken()) {
      return country === "se";
    }
    return geoIP == "se";
  }; */

  useEffect(() => {
    const handleNetent = () => {
      //let netent = "netent";
      const success = (game) => {
        let elem = document.getElementById("fullscr-wrapper");

        // Fullscreen event
        document.addEventListener("fullscreenchange", function () {
          fullscreenEvent();
        });
        document.addEventListener("mozfullscreenchange", function () {
          fullscreenEvent();
        });
        document.addEventListener("webkitfullscreenchange", function () {
          fullscreenEvent();
        });
        document.addEventListener("msfullscreenchange", function () {
          fullscreenEvent();
        });

        // Fire fullscreen event
        function fullscreenEvent() {
          if (
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement
          ) {
            elem.style("width: 100% !important; height: 100% !important");
            game.resize(window.screen.width, window.screen.height);
          } else {
            game.resize(gameWidth, realheight);
          }
        }

        if (isUK) {
          //let canShowRealityCheck = true;
          //let nexSupported = false;
          //let timer = undefined;
          //let netEntExtendRef = undefined;

          game.addEventListener("gameRoundStarted", function () {
            //canShowRealityCheck = false;
          });

          game.addEventListener("gameRoundEnded", function () {
            //canShowRealityCheck = true;
          });

          //netEntExtendRef = game;

          /* const { checkCurrentTime } = realityCheckNetent(
            canShowRealityCheck,
            netEntExtendRef, 
            config.defaultLang
          ); */
          //setInterval(() => checkCurrentTime(), 1000);
          //canShowRealityCheck = false;
          //console.log(canShowRealityCheck);
          //uk reality check part
          game.addEventListener(
            "gameReady",
            function () {
              console.log("reality check");
              //nexSupported = true;
              // In games which supports netent extend, set up the timer on gameready.
              //timer = setInterval(() => checkCurrentTime(), 1000);
            },
            function () {
              // No NetEnt Extend support, set up the timer after 20 seconds (Flash 8 game loading time).
              console.log("no netent extend");
              setTimeout(function () {
                //timer = setInterval(() => checkCurrentTime(), 1000);
              }, 20000);
            }
          );
        }
      };
      const error = (error) => {
        console.log(error);
      };
      window.netent.launch(gameDetails.launchParameters, success, error);
    };
    if (gameDetails && gameDetails.game.vendor === "netent") {
      const script = document.createElement("script");
      script.src =
        gameDetails.launchParameters.staticServer +
        "/gameinclusion/library/gameinclusion.js";
      script.async = true;
      script.addEventListener("load", handleNetent);
      document.body.appendChild(script);
      //handleNetentCall();
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [gameDetails, gameWidth, isUK, realheight]);

  useEffect(() => {
    if (gameDetails && gameDetails.game.vendor === "playngo") {
      const script = document.createElement("script");
      script.setAttribute(
        "src",
        gameDetails.launchURI /*"https://dmtcw.playngonetwork.com/Casino/js?pid=723&gameid=403&lang=en_GB&practice=1&channel=desktop&div=fullscr-wrapper&width=100%&height=100%&embedmode=iframe&password=undefined&origin=https://www.racecasino.com&country=1&demo=2&username=practice"*/
      );
      document.head.appendChild(script);
      //const newScript = document.createElement("script");
      //let IframedViewURL = gameDetails.launchURI.replace("https://dmtcw.playngonetwork.com/Casino/js","https://dmtcw.playngonetwork.com/Casino/IframedView")
      //                var inlineScript = document.createTextNode("function Logout(reason){try {top.location.replace('" + data.origin + "');} catch(e){top.location = 'https://develop.hypercasino.com/en/index';}}function reloadgame(gameId, user) {  document.getElementById('png-game-container').contentWindow.location = 'https://dmtcwstage.playngonetwork.com/Casino/IframedView?pid=" + data.pid + "&gameid=" + data.internal_id + "&username=" + data.user + "&lang=" + data.lang + "&practice=" + data.practice + "&channel=" + data.channel + "&div=game-wrapper&width=100%&height=100%'}");
      /*var inlineScript = document.createTextNode(
        "function Logout(reason){top.location.replace(" +
          pages["games"] +
          ");}function reloadgame(gameId, user) {  _playNGo.getToken('https://dmtcw.playngonetwork.com/Casino/IframedView?pid=" +
           data.pid +
          "&gameid=" +
          data.internal_id +
          "&lang=" +
          data.lang +
          "&practice=" +
          data.practice +
          "&channel=" +
          data.channel +
          "&div=game-wrapper&width=100%&height=100%')}" 
      );
      newScript.appendChild(inlineScript);
      document.head.appendChild(newScript);*/

      return () => {
        document.head.removeChild(script);
        //document.head.removeChild(newScript);
      };
    }
  }, [gameDetails]);

  useEffect(() => {
    //check if player is excluded from game (swe)
    if (isSE || isNL) {
      if (blockedGames.length > 0 && gameDetails) {
        blockedGames.forEach((game) => {
          //console.log("ajde " + game.gameID + " " + gameDetails.game.gameID);
          if (game.gameID === gameDetails.game.gameID) {
            console.log("LOCK GAME");
            //setGameIsBlocked(true);
            //set something for responsible gaming page to display directly exluded games tab
            history.push({
              pathname: pages["my-limits"],
              tab: config.skin === "plc" ? 8 : 7,
            });
          }
        });
      }
    }
    if (isNL) {
      // console.log("CHECK FOR BLOCKED TYPES!");
      if (blockedGameTypes.length > 0 && gameDetails) {
        blockedGameTypes.forEach((type) => {
          if (type.name === gameDetails.game.gameType) {
            console.log("BLOCKED GAME TYPE");
            //set something for responsible gaming page to display directly exluded games tab
            history.push({
              pathname: pages["my-limits"],
              tab: config.skin === "plc" ? 8 : 7,
            });
          }
        });
      }
    }
    if (
      gameDetails &&
      ((bannedLiveCasinoPage && gameDetails.game.gameType === "Live Casino") ||
        (bannedCasinoPage &&
          gameDetails.game.gameType !== "Live Casino" &&
          gameDetails.game.gameType !== "Sports Book") ||
        (bannedSportsbookPage && gameDetails.game.gameType === "Sports Book"))
    ) {
      if (!riskyCountry) {
        sessionStorage.setItem("user_banned_from_page", true);
      } else {
        sessionStorage.setItem("user_from_risky_country", true);
      }
      history.push({
        pathname: pages["support"],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    blockedGames,
    blockedGameTypes,
    bannedCasinoPage,
    bannedLiveCasinoPage,
    bannedSportsbookPage,
    riskyCountry,
    gameDetails,
    isSE,
    pages,
    history,
  ]);

  useEffect(() => {
    if (gameDetails && gameDetails.game.vendor === "blueprint" && isMobile) {
      window.addEventListener("orientationchange", handleOrientationChange);
      window.addEventListener("onresize", handleOrientationChange);
      return () =>
        window.removeEventListener(
          "orientationchange",
          handleOrientationChange
        );
    }
  }, [gameDetails]);

  useEffect(() => {
    async function getGameData(gameId) {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_GAME,
        variables: { gameID: gameId },
      });

      if (loading) return <h3>Loading ...</h3>;
      if (errors) {
        if (
          errors[0].message === "error_game_in_test_mode" ||
          errors[0].message === "error_game_not_active"
        ) {
          console.log("Game in testing mode or innactive");
          window.location.replace(pages["games"]);
        }
      }

      setGameDetails(data.getGame);
      return null;
    }
    getGameData(gameId);
  }, [gameId, apolloClient]);

  useEffect(() => {
    async function getTounaments(internalID) {
      // console.log("ovde " + intervalId);
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_PARTICIPATE_IN_TOURNAMENT,
        variables: { gameID: internalID },
      });
      if (loading) return <h3>Loading ...</h3>;
      if (errors) return <h1>`Error: ${errors}`</h1>;
      //console.log(data);
      setTournaments(data.participateInTournament.tournaments);
      //console.log(data.participateInTournament.tournaments);
      !isSE &&
        data.participateInTournament.tournaments.length > 0 &&
        leaderboard === "" &&
        setShowLeaderboardDialog(true);

      return null;
    }
    gameDetails && getTounaments(gameDetails.game.internalID);
    isDesktop &&
      config.skin !== "plc" &&
      config.skin !== "rac" &&
      config.skin !== "bnk" &&
      gameId !== "sports" &&
      setSidepanel(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apolloClient, gameDetails, leaderboard]);
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
      });
    };
    scrollToTop();
  }, []);

  //console.log(gameDetails);
  useEffect(() => {
    async function getLimits() {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_LIMITS,
      });
      if (loading) return <h3>Loading ...</h3>;
      if (errors) return false;
      return data.getLimits.limits;
    }
    function checkSWEDepositLimit() {
      let hasTimelimitDaily = false;
      let hasTimelimitWeekly = false;
      let hasTimelimitMonthly = false;
      let hasDepositLimit = false;
      getLimits().then((limits) => {
        limits &&
          limits.forEach((limit) => {
            if (limit.limit === "deposit") {
              hasDepositLimit = true;
            }
            if (
              limit.limitType === "daily_timelimit" &&
              limit.initialAmount > 0
            ) {
              hasTimelimitDaily = true;
            }
            if (
              limit.limitType === "monthly_timelimit" &&
              limit.initialAmount > 0
            ) {
              hasTimelimitMonthly = true;
            }
            if (
              limit.limitType === "weekly_timelimit" &&
              limit.initialAmount > 0
            ) {
              hasTimelimitWeekly = true;
            }
          });

        if (
          !hasDepositLimit /*  ||
          !hasTimelimitDaily ||
          !hasTimelimitWeekly ||
          !hasTimelimitMonthly */
        ) {
          localStorage.setItem("sweSetDepositLimit", "show");
          history.push({ pathname: pages["my-limits"], tab: 2 });
        }
      });
    }
    async function getBlockedGams() {
      //QUERY_GET_BLOCKED_GAMES
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_BLOCKED_GAMES,
      });

      if (loading) return <h3>Loading ...</h3>;
      if (errors) return <h1>`Error: ${errors}`</h1>;
      else {
        //console.log(data.getBlockedGames.games);
        setBlockedGames(data.getBlockedGames.games);
        return true;
      }
    }

    async function getBlockedGameTypes() {
      //QUERY_GET_BLOCKED_GAME_TYPES
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_BLOCKED_GAME_TYPES,
      });

      if (loading) return <h3>Loading ...</h3>;
      if (errors) return <h1>`Error: ${errors}`</h1>;
      else {
        //console.log(data.getBlockedGames.games);
        setBlockedGameTypes(data.getBlockedGameTypes.types);
        return true;
      }
    }

    if (/* isUKIP &&  */ !getToken()) {
      if (gameId !== "sports") {
        console.log("Can't open game on logout");
        window.location = "/" + currentLanguage + "/index";
      }
    }

    /* if (isNL && realityCheck !== -1) {
      setNlLimitDialog(true);
    } */

    if (tc === false && country === "gb") {
      //console.log("nema tc");
      window.location = "/" + currentLanguage + "/index";
    }

    // if (hasWithdraw) {
    //   console.log("has withdraw");
    //   setShowWithdrawAlertDialog(true);
    // }
    if (isSE) {
      console.log("deposit limit");
      checkSWEDepositLimit();
      getBlockedGams();
    }

    if (isNL) {
      getBlockedGams();
      getBlockedGameTypes();
    }

    /*  if (
      getToken() &&
      localStorage.getItem("display_responsible_gaming_popup")
    ) {
      intervalId.current = setInterval(() => {
        setShowResponsibleGamingDialog(true);
      }, 10000);
    } */

    //getTounaments();

    //return () => clearInterval(intervalId.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country, currentLanguage, gameId, isSE, isUKIP, leaderboard, pages, tc]);

  useEffect(() => {
    mobileGame(isMobile ? true : false);
    return () => mobileGame(false);
  }, [mobileGame]);

  useEffect(() => {
    async function getTimeout() {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_TIMEOUT,
      });

      if (loading) return <h3>Loading ...</h3>;
      if (errors) {
        if (errors[0].message === "error_timeout_not_exist") {
          setHasTimeout(false);
        } else {
          console.log(errors);
        }
      }

      //setTimeout(data.getTimeout);
      if (data.getTimeout !== null) {
        setHasTimeout(true);
      } else {
        setHasTimeout(false);
      }
    }
    if (getToken() !== null) {
      getTimeout();
    }
  }, [apolloClient]);

  useEffect(() => {
    if (gameDetails !== null) {
      if (
        balance !== undefined &&
        gameDetails.game.gameType === "Live Casino" &&
        balance.real === 0 &&
        balance.bonus > 0
      ) {
        setOnlyBonusDialog(true);
      }

      if (
        wagering &&
        balance &&
        wagering.length > 0 &&
        balance.bonus > 0 &&
        (gameDetails.game.gameType === "Live Casino" ||
          gameDetails.game.name === "Sports")
      ) {
        setBonusLiveAlertDialog(true);
      }
    }
  }, [wagering, balance, gameDetails]);

  useEffect(() => {
    /* redirect from live casino for logout player*/
    //console.log(gameCategory.current);
    if (gameCategory.current === "live-casino" && getToken() === null) {
      window.location = pages["index"];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages]);

  useEffect(() => {
    if (
      wagering &&
      wagering.length !== 0 &&
      gameDetails &&
      gameDetails.game.gameType !== "Live Casino" &&
      gameDetails.game.name !== "Sports"
    ) {
      setBonusConfirmationWrapper(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameDetails]);

  /**
   *  if player has pending timeouts cant play
   **/
  if (hasTimeout) {
    sessionStorage.setItem("TIMEOUT_ACTIVE_FLAG", true);
    window.location = pages["support"];
  }

  const sendRealityCheck = (realityCheckValue) => {
    //console.log(realityCheckValue);
    if (!realityCheckValue) {
      setErrors({ realityCheck: "label_error_reality_check" });
    } else if (parseInt(realityCheckValue) < 15) {
      setErrors({ realityCheck: "label_error_reality_check_min" });
    } else if (parseInt(realityCheckValue) > 60) {
      setErrors({ realityCheck: "label_error_reality_check_max" });
    } else {
      setErrors({});
      setRealityCheck(realityCheckValue);
    }
  };

  async function setRealityCheck(realityCheckValue) {
    setSpinner(true);
    const { loading, errors } = await apolloClient.mutate({
      mutation: MUTATION_UPDATE_PROFILE,
      variables: { realityCheck: parseFloat(realityCheckValue * 60) },
      errorPolicy: "all",
    });

    if (loading) return "Loading ...";
    if (errors) {
      setSpinner(false);
      toast.error(t(errors[0].message), {
        position: "bottom-center",
      });
      return false;
    }
    setSpinner(false);
    window.location.reload(false);
  }

  async function setLeaderboard(leaderboardValue) {
    //console.log(leaderboardValue);
    const { loading, errors } = await apolloClient.mutate({
      mutation: MUTATION_SET_LEADERBOARD_NAME,
      variables: { leaderboard: leaderboardValue },
      errorPolicy: "all",
    });

    if (loading) return "Loading ...";
    if (errors) {
      toast.error(t(errors[0].message), {
        position: "bottom-center",
      });
      return false;
    }
    setShowLeaderboardDialog(false);
    window.location.reload(false);
  }

  /* const [showGameInfo, setshowGameInfo] = useState(false); */
  // let showGameInfo = false;

  useEffect(() => {
    const handler = (event) => {
      if (event.origin === window.location.origin) {
        // console.log("same origin!");
        let data = null;
        if (typeof event.data !== "undefined") {
          try {
            data = JSON.parse(event.data);
          } catch (e) {
            data = event.data;
          }
          // console.log("DATA: " + JSON.stringify(event.data))
          // console.log(data.message)
          if (typeof data.message !== "undefined" && data.message === "games") {
            console.log("-------- games redirect ----------");
            setGameRedirect(true);
          }
        }
      }
    };

    window.addEventListener("message", handler);

    // clean up
    return () => window.removeEventListener("message", handler);
  }, []); // empty array => run only once

  /**
   * stakelogic listener for gameplay events
   */
  useEffect(() => {
    const handler = (event) => {
      if (event.origin.indexOf("stakelogic.com") >= 0) {
        // console.log("same origin!");

        if (event.type === "message") {
          let data = null;
          // console.log(event.data)
          if (typeof event.data !== "undefined") {
            try {
              data = JSON.parse(event.data);
            } catch (e) {
              data = event.data;
            }
            // console.log("DATA: " + JSON.stringify(event.data))
            // console.log("stakelogic message: ", data.event)
            if (
              (typeof data.type !== "undefined" &&
                data.type === "GOTO_LOBBY") ||
              (typeof data.event !== "undefined" && data.event === "GOTO_LOBBY")
            ) {
              console.log("-------- stakelogic games redirect ----------");
              setGameRedirect(true);
            } else if (
              (typeof data.type !== "undefined" && data.type === "CASHIER") ||
              (typeof data.event !== "undefined" && data.event === "CASHIER")
            ) {
              console.log("-------- stakelogic deposit redirect ----------");
              setDepositRedirect(true);
            }
          }
        }
      }
    };

    // console.log("game details ", gameDetails)
    if (
      gameDetails &&
      gameDetails.game &&
      gameDetails.game.vendor === "stakelogic"
    ) {
      window.addEventListener("message", handler);

      // clean up
      return () => window.removeEventListener("message", handler);
    }
  }, [gameDetails]); // empty array => run only once

  if (gameRedirect) {
    return <Redirect to={pages["games"]}></Redirect>;
  }

  if (depositRedirect) {
    return <Redirect to={pages["deposit"]}></Redirect>;
  }

  const onlyBonusDialogClose = () => {
    //sessionStorage.setItem("live-has-bonus", true);
    window.location = pages["index"];
  };

  const cancelActiveBonuses = async () => {
    //QUERY_CANCEL_ALL_BONUSES
    const { loading, errors } = await apolloClient.query({
      query: QUERY_CANCEL_ALL_BONUSES,
    });
    if (loading) return <h3>Loading ...</h3>;
    if (errors) return false;
    else window.location.reload(false);
  };

  /* const confirmReponsibleGaming = async () => {
    //QUERY_ACK_RESPONSIBLE_GAMING_ALERT
    const { loading, errors } = await apolloClient.query({
      query: QUERY_ACK_RESPONSIBLE_GAMING_ALERT,
    });
    if (loading) return <h3>Loading ...</h3>;
    if (errors) return <h1>`Error: ${errors}`</h1>;
    else localStorage.removeItem("display_responsible_gaming_popup");
    setShowResponsibleGamingDialog(false);
    clearInterval(intervalId.current);
    return null;
  }; */

  const startDeposit = () => {
    // if (hasWithdraw && !isUK && !isSE) {
    //   // console.log("has withdraw");
    //   setShowWithdrawAlertDialog(true);
    // } else {
    setShowDeposit(true);
    // }
  };

  const closeDeposit = () => {
    setShowDeposit(false);
  };

  /* const getPlayerToken = (provider, user) => {
    fetch(configData.game + '/token/' + provider + '/' + user)
      .then((res) => res.json())
      .then(
        (result) => {
          return result.response.token;
        },

        (error) => {
          console.log(error);
        },
      );
  }; */
  //player && getPlayerToken("playngo", player.nickName);

  let showFCButton = true;
  if (
    window.navigator.userAgent.includes("Safari/") &&
    window.navigator.userAgent.match(/Mac OS X/) &&
    window.navigator.userAgent.match(/version\/(\d+)/i)
  ) {
    let version = window.navigator.userAgent
      .match(/version\/(\d+)/i)
      .splice("Version/")[1];
    if (parseInt(version) >= 14) {
      showFCButton = false;
    }
  }

  const onClickDepositButton = () => {
    if (showDepositButton) {
      startDeposit(true);
      setShowDepositButton(false);
    } else {
      setShowDepositButton(true);
      setTimeout(() => {
        setShowDepositButton(false);
      }, 5000);
    }
  };

  // console.log(gameDetails && gameDetails.launchURI);

  return (
    <>
      {gameId === "sports" && gameDetails ? (
        <SportsBook
          skin={config.skin}
          token={gameDetails.launchURI}
          pages={pages}
          player={player}
          isUK={isUK}
          isSE={isSE}
          titles={titles}
        />
      ) : (
        <>
          {gameDetails === null ? (
            <GameDetailWrapper>
              <GameSpinner role="status">
                <span className="sr-only"></span>
              </GameSpinner>
            </GameDetailWrapper>
          ) : (
            <GameContent img={gameDetails.game.popUpBanner}>
              <StyledGameWrapper>
                <StyledGameFlex
                  pageWidth={isMobile ? pageWidth + "px" : gameWidth}
                >
                  {config.skin === "rac" && (
                    <>
                      <div style={{ width: "160px" }}></div>
                      {getToken() && (
                        <QuickDeposit>
                          <StyledButton btn onClick={startDeposit}>
                            {t("label_deposit")}
                          </StyledButton>
                          <StyledMx>{t("label_or", "or")}</StyledMx>
                          <StyledButton deposit>
                            {t("label_continue", "continue")}
                          </StyledButton>
                        </QuickDeposit>
                      )}
                    </>
                  )}
                  <GameCommands>
                    {showFCButton && (
                      <FullScreen
                        onClick={
                          gameDetails.game.vendor !== "playngo"
                            ? toggleFullscreen
                            : gameOnFullScr
                        }
                      />
                    )}
                    <Close onClick={() => history.push(pages["index"])} />
                  </GameCommands>
                </StyledGameFlex>

                <GameFullscreanWrapper
                  mobile={isMobile}
                  pageWidth={
                    isMobile
                      ? gameDetails.game.vendor === "blueprint"
                        ? "100vw"
                        : pageWidth + "px"
                      : gameWidth
                  }
                  pageHeight={
                    isMobile
                      ? gameDetails.game.vendor === "blueprint" && !isMobile
                        ? "100vh"
                        : gameDetails.game.vendor === "blueprint" && isMobile
                          ? "100%"
                          : pageHeight + "px"
                      : realheight
                  }
                  /* fullscreen={
                    inFullscreenMode &&
                    gameDetails.game.vendor === "netent" &&
                    !isMobile
                  } */
                  id={
                    gameDetails.game.vendor !== "playngo"
                      ? "fullscr-wrapper"
                      : "fs-wrapper"
                  }
                  ref={maximizableElement}
                >
                  {isUK && (
                    <>
                      <GameSessionStats
                        gross={gross}
                        currency={playerCurrency}
                        time={time}
                        gameWidth={gameWidth}
                        server={server}
                      />
                      {gameDetails.game.vendor === "playngo" && !isMobile && (
                        <div id="fullscr-wrapper"></div>
                      )}
                    </>
                  )}
                  <IFrame
                    //fullscreen={inFullscreenMode}
                    id="neGameClient"
                    title="myFrame"
                    //sandbox="allow-top-navigation-by-user-activation allow-popups allow-scripts allow-same-origin allow-forms"
                    src={gameDetails.launchURI}
                    scrolling="no"
                    allow="autoplay"
                    width="100%"
                    height={
                      /* gameDetails.game.vendor === "playngo" && isUK
                        ? "calc(100% - 21px)"
                        : */ "100%"
                    }
                    frameBorder="no"
                    allowFullScreen={!isMobile}
                    webkitallowfullscreen={!isMobile}
                    mozallowfullscreen={!isMobile}
                    style={{
                      minWidth: "100%",
                      maxHeight:
                        /* isMobile && isUK
                          ? "calc(100% - 21px)"
                          : isUK && inFullscreenMode && !isMobile
                          ? "calc(100% - 21px)"
                          : "100%", */
                        isUK ? "calc(100% - 21px)" : "100%",
                      padding: 0,
                      margin: 0,
                      border: "none",
                    }}
                  />
                  {isUK && gameDetails.game.vendor === "netent" && (
                    <>
                      <div tabIndex="1" style={{ display: "none" }}></div>
                      <div style={{ display: "none" }}></div>
                    </>
                  )}
                  {isMobile && gameId !== "sports" && (
                    <DepositInGameBox
                      show={showDepositButton}
                      onTouchStart={(e) =>
                        touchStartHandlerDeposit(
                          e,
                          gameDetails.game.vendor === "playngo"
                        )
                      }
                    >
                      <img
                        className="moveIconStyle"
                        src={arrowAltTwo}
                        alt="arrows-alt"
                      />
                      <DepositInGameWrapper
                        show={showDepositButton}
                        onClick={() => onClickDepositButton()}
                      >
                        {t("label_deposit_ingame", "deposit $")}
                      </DepositInGameWrapper>
                    </DepositInGameBox>
                  )}
                  {isSE && isMobile && (
                    <GamePanelSE>
                      <GamePanelHeader
                        onTouchStart={(e) => touchStartHandler(e)}
                      >
                        <img
                          className="moveIconStyle"
                          src={arrowAlt}
                          alt="arrows-alt.svg"
                        />
                      </GamePanelHeader>
                      <StyledSELink href="https://stodlinjen.se/#!/spelberoende-test-pgsi">
                        <img src={sjaelvtest} alt="sjaelvtest.svg"></img>
                      </StyledSELink>
                      <StyledLink semob to={pages["my-limits"]}>
                        <img src={spelgraenser} alt="spelgraenser.svg"></img>
                      </StyledLink>

                      <StyledSELink href="https://www.spelpaus.se/?scos=true">
                        <img src={spelpaus} alt="spelpaus.svg"></img>
                      </StyledSELink>
                    </GamePanelSE>
                  )}
                </GameFullscreanWrapper>
                {!isMobile && (
                  <>
                    {/* <GameCasinoTimeWrapper>
                      <GameAlignCenter>
                        <Time
                          player={player}
                          isInGame={true}
                          skin={config.skin}
                          server={server}
                        />
                      </GameAlignCenter>
                        {isSE && (
                        <GameAlignCenter swe>
                          <a href="https://stodlinjen.se/#!/spelberoende-test-pgsi">
                            <img
                              src={
                                currentTheme === THEME_DARK
                                  ? require("common/src/assets/img/sjaelvtest_dark.svg")
                                  : require("common/src/assets/img/sjaelvtest.svg")
                              }
                              alt="sjaelvtest.svg"
                            ></img>
                          </a>
                          <Link to={pages["my-limits"]}>
                            <img
                              src={
                                currentTheme === THEME_DARK
                                  ? require("common/src/assets/img/spelgraenser_dark.svg")
                                  : require("common/src/assets/img/spelgraenser.svg")
                              }
                              alt="spelgraenser.svg"
                            ></img>
                          </Link>
                          <a href="https://www.spelpaus.se/?scos=true">
                            <img
                              src={
                                currentTheme === THEME_DARK
                                  ? require("common/src/assets/img/spelpaus_dark.svg")
                                  : require("common/src/assets/img/spelpaus.svg")
                              }
                              alt="spelpaus.svg"
                            ></img>
                          </a>
                        </GameAlignCenter>
                      )}
                    </GameCasinoTimeWrapper> */}
                    <SidepanelButton>
                      {sidepanel ? (
                        <div
                          onClick={() =>
                            (
                              // eslint-disable-next-line no-sequences
                              setSidepanel(!sidepanel), setClearGameSearch(true)
                            )
                          }
                        >
                          <StyledDoubleArrowsRight width="20px" />
                        </div>
                      ) : (
                        <div
                          onClick={() =>
                            (
                              // eslint-disable-next-line no-sequences
                              setSidepanel(!sidepanel),
                              setClearGameSearch(false)
                            )
                          }
                        >
                          <StyledDoubleArrowsLeft width="20px" />
                        </div>
                      )}
                    </SidepanelButton>

                    {gameDetails &&
                      gameDetails.game &&
                      gameDetails.game.textDescription &&
                      gameDetails.game.textDescription !== "" && (
                        <div className="game-info col mt-3 mb-2">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: t(gameDetails.game.textDescription, ""),
                            }}
                          ></div>
                        </div>
                      )}
                  </>
                )}
              </StyledGameWrapper>
              {!isMobile && (
                <SidePanel
                  sidepanel={sidepanel}
                  onToggleSearchShow={onToggleSearchShow}
                  setShowChallengeDialog={setShowChallengeDialog}
                  playerCurrency={playerCurrency}
                  server={server}
                  player={player}
                  gameDetails={gameDetails}
                  pages={pages}
                  realheight={realheight}
                  sidepanelHeight={sidepanelHeight}
                  currentLanguage={currentLanguage}
                  currency={playerCurrency}
                  imagesPath={config.imagesPath}
                  clearGameSearch={clearGameSearch}
                  gameImagePath={config.gameImagePath}
                  skin={config.skin}
                  tournaments={tournaments}
                  setShowTournamentPopover={setShowTournamentPopover}
                />
              )}
            </GameContent>
          )}
        </>
      )}
      <TournamentPopover
        showModal={showTournamentPopover}
        handleCancel={() => setShowTournamentPopover(false)}
        tournamentDescription={tournamentDescription}
        skin={config.skin}
      />
      <LeaderboardDialog
        showModal={showLeaderboardDialog}
        handleProceed={(e) => setLeaderboard(e)}
        skin={config.skin}
      />
      <OnlyBonusDialog
        showModal={onlyBonusDialog}
        handleCancel={() => onlyBonusDialogClose()}
        skin={config.skin}
      />
      <BonusLiveAlertDialog
        showModal={bonusLiveAlertDialog}
        handleProceed={() => cancelActiveBonuses()}
        handleCancel={() => onlyBonusDialogClose()}
        skin={config.skin}
        sports={gameId === "sports"}
      />
      <BonusConfirmationWrapper
        showModal={bonusConfirmationWrapper}
        handleProceed={() => setBonusConfirmationWrapper()}
        skin={config.skin}
      />

      {/* pokrenuti na in game deposit */}
      {showDeposit && (
        <FullPageOverlay gameWindow>
          <IngameDeposit isLandscape={isLandscape}>
            <Close onClick={closeDeposit} />
            <Deposit
              currentTheme={currentTheme}
              server={server}
              bannedDepositPage={bannedDepositPage}
              hasWithdraw={hasWithdraw}
              cancelWithdrawal={cancelWithdrawal}
              player={player}
              riskyCountry={riskyCountry}
              preselectedDeposit={""}
              setSpinner={setSpinner}
              isMobile={isMobile}
              isTablet={isTablet}
              inGame={true}
              closeIngame={closeDeposit}
              depositList={depositList}
              setShowWithdrawAlertDialog={setShowWithdrawAlertDialog}
              setSweLimitDialog={setSweLimitDialog}
              pages={pages}
              setPxDepositStart={setPxDepositStart}
              firstDeposit={firstDeposit}
            />
          </IngameDeposit>
        </FullPageOverlay>
      )}
      {/*  <ResponsibleGamingDialog
        showModal={showResponsibleGamingDialog}
        handleProceed={() => confirmReponsibleGaming()}
        skin={config.skin}
      /> */}
      <SetRealityCheckDialog
        showModal={realityCheck === -1}
        server={server}
        grossResults={grossResults}
        player={player}
        pages={pages}
        errors={errors}
        handleProceed={(e) => sendRealityCheck(e)}
        skin={config.skin}
      />
      <ChallengeDialog
        showModal={showChallengeDialog}
        handleProceed={() => setShowChallengeDialog(false)}
        skin={config.skin}
      />
      <RealityCheckDialog
        showModal={showRealityCheckDialog}
        stats={rcValue}
        server={server}
        grossResults={grossResults}
        player={player}
        pages={pages}
        handleProceed={() => setshowRealityCheckDialog(false)}
        handleCancel={() =>
          (window.location = "/" + currentLanguage + "/index")
        }
        skin={config.skin}
      />
      {/* {showSessionLimitDialog && (
        <SessionLimitDialog
          showModal={showSessionLimitDialog}
          handleCancel={() =>
            (window.location = "/" + currentLanguage + "/index")
          }
        />
      )} */}
    </>
  );
};

export default withRouter(GameWindow);
